import { ResponsiveBar } from "@nivo/bar";
import React, { Component } from "react";
import StaticClass from "../../utils/staticClass"
const BarGroup = ({ data, keys, labelX, labelY, type, legend }) => {
  return (
    <ResponsiveBar
      innerPadding={20}
      // maxValue={100}
      label={(d) => (`${StaticClass.formatPrice(d.value)}%`)}
      data={data}
      keys={keys}
      // indexBy="country"
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.2}
      groupMode={"grouped"}
      valueScale={{ type: "linear" }}
      colors={{ scheme: "set3" }}
      borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 0,
        tickPadding: 5,
        tickRotation: 0,
        legend: labelX,
        legendPosition: "middle",
        legendOffset: 32,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: labelY,
        legendPosition: "middle",
        legendOffset: -40,
      }}
      labelSkipWidth={0}
      labelSkipHeight={0}
      labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
      legends={
        legend
          ? [
              {
                dataFrom: "keys",
                anchor: "bottom-right",
                direction: "column",
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 5,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: "left-to-right",
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]
          : []
      }
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      tooltip={function (e) {
        return (
              <div>
                <div>Tổng số dự án: {e.data[`${e.id}_hover`]}</div>
                <div>Cơ bản hoàn thành: {e.data[`${e.id}_CoBanHT`]}</div>
                <div>Đang triển khai: {e.data[`${e.id}_dang`]}</div>
                <div>Chưa triển khai: {e.data[`${e.id}_chua`]}</div>
                <div>Chậm triển khai: {e.data[`${e.id}_cham`]}</div>
              </div>
            );
      }}
    ></ResponsiveBar>
  );
};
export default BarGroup;
